export default __webpack_public_path__ + "static/media/syrie_carte_1-min_NL.e62ecf65.png";